export function getLocalStorage(key) {
    const item = window.localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  }
  
  export function setLocalStorage(key, value) {
    window.localStorage.setItem(key, JSON.stringify(value));
  }
  